import { render, staticRenderFns } from "./PeriodsEditor.vue?vue&type=template&id=db4b67f2&scoped=true"
import script from "./PeriodsEditor.vue?vue&type=script&lang=js"
export * from "./PeriodsEditor.vue?vue&type=script&lang=js"
import style0 from "./PeriodsEditor.vue?vue&type=style&index=0&id=db4b67f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b67f2",
  null
  
)

export default component.exports